import styled, { keyframes } from 'styled-components';

import { ImageBackgroundLogoIbFullscreen } from '~/assets/images';

const appearOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
export const Container = styled.div`
  background: url(${ImageBackgroundLogoIbFullscreen}) 0% / cover fixed,
    ${(props) => props.theme.colors.background};

  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 45.3rem;

  padding: 2rem;

  animation: ${appearOpacity} 0.5s ease-in;

  @media (min-width: 768px) {
    padding: 0;
  }

  /* Logo */
  > svg {
    margin-top: 5.6rem;
  }

  > form {
    width: 100%;
    margin: 2.2rem 0;

    > div {
      & + div {
        margin-top: 2.2rem;
      }
    }
  }
`;

export const Title = styled.h1`
  font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
  font-size: 3.8rem;
  color: ${({ theme }) => theme.colors.yellow};

  text-align: center;

  margin-top: 3.6rem;
`;

export const Subtitle = styled.h2`
  font-size: 2.2rem;
  letter-spacing: 0.22rem;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.white};

  margin-top: 0.5rem;
`;

export const OptionsContainer = styled.section`
  display: flex;
  justify-content: space-between;

  width: 100%;

  margin-bottom: 4rem;

  > label {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    cursor: pointer;

    > input {
      cursor: pointer;
    }

    > span {
      font-size: 1.6rem;
      color: #ffffff;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  > span {
    border-bottom: 1px solid #ffffff;
    padding-bottom: 0.5px;

    transition: ${({ theme }) => theme.transition.default};

    > a {
      font-size: 1.6rem;
      color: #ffffff;
    }

    &:hover {
      border-color: ${({ theme }) => theme.colors.yellow};

      > a {
        color: ${({ theme }) => theme.colors.yellow};
      }
    }
  }
`;

export const SignUpNow = styled.p`
  width: 100%;
  max-width: 29.8rem;

  font-size: 1.6rem;
  color: #ffffff;

  text-align: center;

  margin: 3.6rem 0;

  > a {
    font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
    background: none;
    color: inherit;

    transition: ${({ theme }) => theme.transition.default};

    &:hover {
      color: ${({ theme }) => theme.colors.yellow};
    }
  }
`;

export const ImStudent = styled.p`
  text-align: center;
  margin-bottom: 2.4rem;

  > a {
    font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
    font-size: 1.8rem;
    color: ${({ theme }) => theme.colors.yellow};

    letter-spacing: 1.44px;

    transition: ${({ theme }) => theme.transition.default};

    &:hover {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const Slogan = styled.div`
  max-width: 30rem;
  width: 100%;

  margin-bottom: 5.6rem;

  > p {
    font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
    font-size: 3rem;
    letter-spacing: 0.9px;
    color: #ffffff;

    text-align: center;
  }

  @media (min-width: 768px) {
    /* margin-top: 6.4rem; */
  }
`;
